<template>
  <v-layout>
    <v-flex>
      <v-text-field
        @change="inputHandler"
        v-model="hour"
        label="Hour"
        type="number"
      />
    </v-flex>
    <v-flex>
      <v-text-field
        @change="inputHandler"
        v-model="min"
        label="Minute"
        type="number"
      />
    </v-flex>
    <v-flex>
      <v-text-field
        @change="inputHandler"
        v-model="sec"
        label="Second"
        type="number"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { Time } from "@/lib/Time";

export default {
  props: ["value"],
  data() {
    return {
      hour: 0,
      min: 0,
      sec: 0
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.updateData(newVal);
      }
    }
  },
  computed: {
    duration() {
      return Time.duration.create({
        [Time.unit.second]: parseInt(this.sec),
        [Time.unit.hour]: parseInt(this.hour),
        [Time.unit.minute]: parseInt(this.min)
      });
    }
  },
  methods: {
    inputHandler() {
      if (Number.isNaN(parseInt(this.sec)) || this.sec < 0) this.sec = 0;
      if (this.sec > 59) this.sec = 59;
      if (Number.isNaN(parseInt(this.min)) || this.min < 0) this.min = 0;
      if (this.min > 59) this.min = 59;

      if (Number.isNaN(parseInt(this.hour)) || this.hour < 0) this.hour = 0;
      this.$emit("input", this.duration);
    },
    updateData(duration) {
      this.hour = Time.duration.as(duration, Time.unit.hour, true);
      this.min = Time.duration.get(duration, Time.unit.minute);
      this.sec = Time.duration.get(duration, Time.unit.second);
    }
  }
};
</script>
